import React, { createContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import classNames from "classnames";
// import PaymentDetail from "./components/PaymentDetail";
import CustomerServices from "../../../services/OrderingServices/CustomerServices";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import Detail from "../Components/Detail";
import CreditLogs from "../Components/CreditLogs";

export const CustomerContext = createContext();

const CustomerDetail = () => {
  const { id } = useParams();

  const [customerDetail, setCustomerDetail] = useState();
  const [orderDetail, setOrderDetail] = useState([]);
  const [activeTab, setActiveTab] = useState("1"); // Set the initial active tab to "1"
  const [itemDetailLoaded, setItemDetailLoaded] = useState(false);
  const [addressDetailLoaded, setAddressDetailLoaded] = useState(false);
  const [paymentDetailLoaded, setPaymentDetailLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const response = await CustomerServices.getCustomerDetail(id);
        console.log("🚀 ~ response:", response);
        setCustomerDetail(response);
        console.log(response);
      } catch (error) {
        console.log("🚀 ~ error:", error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const breadcrumbItems = [{ title: "Back To List ", link: "/customer-list" }];

  // const toggleTab = (tab) => {
  //   if (activeTab !== tab) setActiveTab(tab);
  // };
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      // Mark item detail as loaded if tab 2 is selected for the first time
      if (tab === "2" && !itemDetailLoaded) {
        setItemDetailLoaded(true);
      }

      // Mark address detail as loaded if tab 3 is selected for the first time
      if (tab === "3" && !addressDetailLoaded) {
        setAddressDetailLoaded(true);
      }

      // Mark payment detail as loaded if tab 4 is selected for the first time
      if (tab === "4" && !paymentDetailLoaded) {
        setPaymentDetailLoaded(true);
      }

      setActiveTab(tab);
    }
  };

  return (
    <div className="page-content">
      <CustomerContext.Provider value={customerDetail}>
        <div class="container-fluid">
          <BreadCrumb
            pageTitle="Customer"
            title="Customer Detail"
            breadcrumbItems={breadcrumbItems}
          />
        </div>

        <Detail />
        <Row className="py-auto">
          <Col lg={12}>
            <div className="py-auto">
              <div className="d-flex">
                <Nav
                  pills
                  className="animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1"
                  role="tablist"
                >
                  <NavItem>
                    <NavLink
                      href="#"
                      className={classNames({
                        active: activeTab === "1",
                      })}
                      onClick={() => {
                        toggleTab("1");
                      }}
                      title="Credit Logs"
                    >
                      <i className="ri-airplay-fill d-inline-block d-md-none"></i>{" "}
                      <span
                        className="d-none d-md-inline-block fw-bold"
                        style={{ color: "rgb(0,37,56)" }}
                      >
                        Credit Logs
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="#"
                      className={classNames({
                        active: activeTab === "2",
                      })}
                      onClick={() => {
                        toggleTab("2");
                      }}
                      title="Item Detail"
                    >
                      <i className="ri-list-unordered d-inline-block d-md-none"></i>{" "}
                      <span
                        className="fw-bold"
                        style={{ color: "rgb(0,37,56)" }}
                      >
                        Item Detail
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="#"
                      className={classNames({
                        active: activeTab === "3",
                      })}
                      onClick={() => {
                        toggleTab("3");
                      }}
                      title="Delivery Detail"
                    >
                      <i className="ri-list-unordered d-inline-block d-md-none"></i>{" "}
                      <span
                        className="d-none d-md-inline-block fw-bold"
                        style={{ color: "rgb(0,37,56)" }}
                      >
                        Delivery Detail
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="#"
                      className={classNames({
                        active: activeTab === "4",
                      })}
                      onClick={() => {
                        toggleTab("4");
                      }}
                      title="Payment Detail"
                    >
                      <i className="ri-list-unordered d-inline-block d-md-none"></i>{" "}
                      <span
                        // className="d-none d-md-inline-block fw-bold"
                        style={{ color: "rgb(0,37,56)" }}
                      >
                        Payment Detail
                      </span>
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
              <Card>
                <CardBody>
                  <TabContent activeTab={activeTab} className="pt-4 text-muted">
                    <TabPane tabId="1">
                      <CreditLogs
                        creditLog={customerDetail?.creditLogs}
                        loading={loading}
                      />
                    </TabPane>
                    <TabPane tabId="2">
                      {/* {itemDetailLoaded && <ItemDetail />} */}
                    </TabPane>
                    <TabPane tabId="3">
                      {/* {addressDetailLoaded && <AddressDetail />} */}
                    </TabPane>
                    <TabPane tabId="4">
                      {/* {paymentDetailLoaded && <PaymentDetail />} */}
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
      </CustomerContext.Provider>
    </div>
  );
};

export default CustomerDetail;
